/* ==========================================================================
   SearcherFlightHotel > Loading
   ========================================================================== */

/* Modules */
const ModalLoading = require('@bluekiri/alexandria-contrib-components/components/modal-loading/client/js');
const prototype = require('./prototype');
const config = require('../config');

/* Init  */
function initLoading(selector, configuration) {
    /* Instance references */
    const result = Object.create(prototype);

    // Config
    result.config = config;

    // modal
    result.modal = ModalLoading(`${selector} [data-component="Modal"]`, {
        ...configuration.loading
    });

    return result;
}

module.exports = {
    initLoading
};
